// eslint-disable-next-line
import axios from 'axios'
import store from "@/store";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL =
  params.PROD.CLIENT.RETURN_SOLICITATION.RETURN_SOLICITATION.BASE_URL;
let EMAIL_URL =
  params.PROD.CLIENT.RETURN_SOLICITATION.RETURN_SOLICITATION.EMAIL_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.CLIENT.RETURN_SOLICITATION.RETURN_SOLICITATION.BASE_URL;
  EMAIL_URL =
    params.DEV.CLIENT.RETURN_SOLICITATION.RETURN_SOLICITATION.EMAIL_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.CLIENT.RETURN_SOLICITATION.RETURN_SOLICITATION.BASE_URL;
  EMAIL_URL =
    params.QA.CLIENT.RETURN_SOLICITATION.RETURN_SOLICITATION.EMAIL_URL;
}

const { customer } = store.state;

const request = {
  return_request: {
    is_open: "1",
    customer: {
      sapcode: customer.sapcode,
      // eslint-disable-next-line
      email: customer.email,
    }
  }
};

const clearRequest = () => {
  request.return_request.requests = [];
};

const registerSolicitation = req => {
  return axios
    .post(`${BASE_URL}/create`, req)
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
};

const getRequestItems = ({ requests }) => {
  let items = [];
  requests.forEach(request => {
    pushResquesItems(items, request.items);
  });
  return items;
};

const pushResquesItems = (finalItems, requestItems) => {
  requestItems.forEach(item => {
    finalItems.push(item);
  });
};

const performSendEmail = ({ email, name, items }) => {
  return axios.post(`${EMAIL_URL}/request/send`, {
    email,
    name,
    items
  });
};

const sendConfirmationEmail = request => {
  let email = request.customer.email;
  let items = getRequestItems(request);
  return performSendEmail({
    // TODO: add customer name to customer object in request
    name,
    email,
    items
  });
};

export default {
  request,
  registerSolicitation,
  sendConfirmationEmail,
  clearRequest
};
